import React from 'react';

function ProjectRow({ client, userList }) {
  // Ensure proper default values to prevent NaN issues
  const totalOrderPrice = client.projects.reduce(
    (sum, project) => sum + parseInt(project.order_price || 0, 10),
    0
  );
  const totalCostPrice = client.projects.reduce(
    (sum, project) => sum + parseInt(project.total_cost_price || 0, 10),
    0
  );
  const totalDiff = totalOrderPrice - totalCostPrice;

  return (
    <>
      {/* Render the client name */}
      <tr>
        <td colSpan="5" style={{ backgroundColor: '#ebf1de', fontWeight: 'bold' }}>
          {client.client_name || 'Unknown Client'}
        </td>
      </tr>

      {/* Render each project under this client */}
      {client.projects.map((project) => {
        const mainManager = userList.find((user) => user.id === project.manager_id);
        const mainManagerName = mainManager ? mainManager.name : 'No Manager Assigned';

        const subManager = userList.find((user) => user.id === project.sub_manager_id);
        const subManagerName = subManager ? subManager.name : 'No Sub-Manager Assigned';

        const orderPrice = project.order_price || 0;
        const costPrice = project.total_cost_price || 0;

        const totalRate = orderPrice > 0
          ? Math.round(((orderPrice - costPrice) / orderPrice) * 100 * 10) / 10
          : 0;
        const totalRateClass = totalRate < 0 ? 'deficit' : '';

        const orderRate = orderPrice > 0 ? Math.min((orderPrice / costPrice) * 100, 100) : 0;
        const costRate = costPrice > 0 ? Math.min((costPrice / orderPrice) * 100, 100) : 0;

        return (
          <React.Fragment key={project.id}>
            <tr>
              <td>
                <a href={`/projectDetails/${project.id}`}>{project.name_abbreviation}</a>
                <div className="text-right" style={{ float: 'right' }}>
                  <a href={`/projectEdit/${project.id}`} className="btn btn-default">
                    <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                  </a>
                </div>
              </td>
              <td style={{ width: '12%', textAlign: 'center' }}>
                {['Development', 'Maintenance', 'Hosting', 'Not Ordered'][project.category_cd - 1]}
              </td>
              <td style={{ width: '18%', textAlign: 'center' }}>
                {mainManagerName && <div>【Main】{mainManagerName}</div>}
                {subManagerName && <div>【Sub】{subManagerName}</div>}
              </td>
              <td style={{ width: '16%' }}>
                {project.start_date} ～ {project.end_date}
              </td>
              <td>
                <table className="cost_table">
                  <tbody>
                    <tr>
                      <td className="rate">₹{orderPrice}</td>
                      <td className="graph">
                        <span
                          className="bar first_color"
                          style={{ width: `${orderRate}%` }}
                        ></span>
                      </td>
                      <td rowSpan="2" className={`total_rate ${totalRateClass}`}>
                        {totalRate}%
                        {/* <a href={`/batch_calculation/?project_id=${project.id}&md=1`}>
                          <span
                            className="btn btn-default glyphicon glyphicon-repeat"
                            aria-hidden="true"
                          ></span>
                        </a> */}
                      </td>
                    </tr>
                    <tr>
                      <td className="rate">₹{costPrice}</td>
                      <td className="graph">
                        <span
                          className="bar second_color"
                          style={{ width: `${costRate}%` }}
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </React.Fragment>
        );
      })}

      {/* Render total sales and cost at the bottom */}
      <tr>
        <td colSpan="5" style={{ textAlign: 'right'}}>
          【Total Sales】 ₹{totalOrderPrice.toLocaleString()} － 【Total Cost】 ₹{totalCostPrice.toLocaleString()} ＝
          <span
            className="total_rate_display"
            style={{
              paddingRight: '10px',
              color: totalOrderPrice < totalCostPrice ? 'red' : 'inherit',
            }}
          >
            ₹{totalDiff.toLocaleString()}
          </span>
        </td>
      </tr>
    </>
  );
}

export default ProjectRow;
